module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/cooling-off-day.jpg?v=2905c426";